import styled from 'styled-components';

export const LandingPageTestimonials = styled.div<{ itemsPerSlide?: number }>`
  padding: 10px 10% 100px;
  width: 100%;

  .container-content {
    max-width: 1200px;
    margin: 0 auto;
    border-top: 1px solid var(--color-text-footer);
    padding-top: 80px;
  }

  .testimonials-header {
    text-align: center;
    margin-bottom: 60px;

    h2 {
      color: #807f7e;
      font-size: 36px;
      font-weight: 900;
      margin-bottom: 20px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    p {
      color: #807f7e;
      font-size: 18px;
      line-height: 1.6;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  .testimonials-carousel {
    position: relative;
    margin-bottom: 60px;

    .carousel-container {
      overflow: hidden;
      border-radius: 12px;
    }

    .testimonials-grid {
      display: flex;
      transition: transform 0.5s ease-in-out;
      width: 100%; /* Cada slide ocupa 100% do container */
    }

    .testimonials-slide {
      display: grid;
      grid-template-columns: repeat(${props => props.itemsPerSlide || 2}, 1fr);
      gap: 30px;
      width: 100%;
      flex-shrink: 0;
      padding: 20px 0px;
    }
  }

  .carousel-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    margin-top: 40px;

    .carousel-arrow {
      background: white;
      border: 2px solid var(--color-progress-background);
      border-radius: 50%;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        border-color: var(--primary-color);
        transform: scale(1.1);
      }

      img {
        width: 20px;
        height: 20px;
        transition: transform 0.3s ease;
      }

      &.prev img {
        transform: rotate(0deg);
      }

      &.next img {
        transform: rotate(180deg);
      }
    }

    .carousel-dots {
      display: flex;
      gap: 10px;

      .dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: none;
        background-color: var(--color-progress-background);
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
          background-color: var(--primary-color);
          transform: scale(1.2);
        }

        &:hover {
          background-color: var(--secondary-color);
        }
      }
    }
  }

  .cta-section {
    text-align: center;

    .cta-button {
      background: linear-gradient(to right, #5e287e, #d82e88);
      color: white;
      border: none;
      padding: 18px 40px;
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      border-radius: 50px;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-bottom: 10px;
      display: block;
      margin-left: auto;
      margin-right: auto;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(var(--primary-color-rgb), 0.3);
      }
    }

    .cta-subtitle {
      color: var(--primary-color);
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 5% 60px;

    .testimonials-slide {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .testimonials-header {
      margin-bottom: 40px;

      h2 {
        font-size: 24px;
      }

      p {
        font-size: 16px;
      }
    }

    .carousel-controls {
      gap: 20px;
      margin-top: 30px;

      .carousel-arrow {
        width: 40px;
        height: 40px;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
`;

export const TestimonialCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(155, 153, 175, 0.15);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }

  .testimonial-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .rating {
    margin: 15px 0px;

    .star {
      color: #ddd;
      font-size: 18px;
      margin-top: 30px;

      &.filled {
        color: #5e287e;
      }
    }
  }

  .testimonial-text {
    color: var(--text-color);
    line-height: 1.6;
    margin-bottom: 25px;
    flex-grow: 1;
    font-size: 15px;
  }

  .testimonial-author {
    border-top: 1px solid #ffeaf6;
    padding-top: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: auto;

    .avatar {
      .avatar-placeholder {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
        font-weight: 700;
        text-transform: uppercase;
      }
    }

    .author-info {
      h4 {
        color: #807f7e;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 4px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      span {
        color: var(--secondary-color);
        font-size: 13px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 25px 20px;

    .quote-icon svg {
      width: 24px;
      height: 24px;
    }

    .rating .star {
      font-size: 16px;
    }

    .testimonial-text {
      font-size: 14px;
    }

    .testimonial-author {
      .avatar .avatar-placeholder {
        width: 40px;
        height: 40px;
        font-size: 16px;
      }

      .author-info h4 {
        font-size: 14px;
      }

      .author-info span {
        font-size: 12px;
      }
    }
  }
`;
